import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { COMPANY } from "@/lib/assets";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-white" data-testid="impressum-page">
      <Header />
      <main className="pt-28 md:pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#0A3B2C] hover:underline mb-8" data-testid="impressum-back-link">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>

          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C] mb-3">Rechtliches</div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0A3B2C] mb-10" style={{ fontFamily: "Outfit, sans-serif" }}>
            Impressum
          </h1>

          <div className="prose prose-sm max-w-none space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Angaben gemäß § 5 TMG</h2>
              <p>
                faktor-direkt<br />
                {COMPANY.street}<br />
                {COMPANY.city}<br />
                Deutschland
              </p>
              <p className="mt-3">
                Vertreten durch die Geschäftsführer:<br />
                {COMPANY.managingDirectors}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Kontakt</h2>
              <p>
                Telefon: {COMPANY.phone}<br />
                E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#0A3B2C] underline">{COMPANY.email}</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Berufsbezeichnung & Tätigkeit</h2>
              <p>
                Tätigkeitsschwerpunkt: Spezialisierter Direktvertrieb für Stadtwerke, Gemeindewerke,
                regionale Energieversorger und kommunal geprägte Versorgungsunternehmen.
              </p>
              <p className="mt-3">Verliehen in: Bundesrepublik Deutschland</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Redaktionell verantwortlich</h2>
              <p>
                {COMPANY.managingDirectors}<br />
                {COMPANY.street}, {COMPANY.city}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">EU-Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0A3B2C] underline">
                  https://ec.europa.eu/consumers/odr/
                </a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Haftung für Inhalte</h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                Tätigkeit hinweisen.
              </p>
              <p className="mt-3">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend
                entfernen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Haftung für Links</h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
                übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
                Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">Urheberrecht</h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
